import React from 'react';
import ReactDOM from 'react-dom';

import * as serviceWorker from './serviceWorker';

import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import CssBaseline from '@material-ui/core/CssBaseline';

import {theme} from './themes/app_theme';
import Application from './adminComponent/ApplicationContainer';
import './index.css';

import { BrowserRouter as Router } from "react-router-dom";

ReactDOM.render(
  <MuiThemeProvider theme={theme}>
    <CssBaseline />
    <Router>
      <Application />
    </Router>
  </MuiThemeProvider>
  ,
  document.getElementById('root')
);


serviceWorker.unregister();
//serviceWorker.register();
